// src/pages/misc/public/ArticlePage.tsx
// [HANDOFF] ARTICLE (/como-funciona/:slug). Looks the slug up in learnContent.ts (ARTICLES). If it does not exist it shows "No encontramos ese
//   artículo." with a link back. Otherwise: title, excerpt as lead, "<n> min de lectura", then one <p> per string in `body`.
// [URL-RENAME] /como-funciona/:slug -> /how-it-works/:slug (the slugs themselves, e.g. que-es-un-crm, are Spanish too; rename only if asked).
//   The back links point at /como-funciona; change them with the route.
import { Link, useParams } from 'react-router-dom';
import PublicShell from './PublicShell';
import { findArticle } from './learnContent';

const ArticlePage = () => {
  const { slug } = useParams();
  const article = findArticle(slug || '');

  if (!article) {
    return (
      <PublicShell pageTitle="Artículo" kicker="Cómo funciona" title="No encontramos ese artículo.">
        <p className="pub-lead"><Link to="/como-funciona">Volver a cómo funciona</Link></p>
      </PublicShell>
    );
  }

  return (
    <PublicShell pageTitle={article.title} kicker={article.topic} title={article.title} lead={article.excerpt}>
      <p className="pub-note">{article.minutes} min de lectura</p>
      <article className="pub-read">
        {article.body.map((p) => <p key={p}>{p}</p>)}
      </article>
      <p className="pub-actions">
        <Link className="pub-textlink" to="/como-funciona">← Todos los temas</Link>
      </p>
    </PublicShell>
  );
};

export default ArticlePage;
